export const DAC_DOCS_BASE_URL = 'https://go.atlassian.com/dac/platform/slos/tome/';

export const DAC_DOCS_INTRO_URL = 'https://go.atlassian.com/dac/platform/slos/intro/';

export const DAC_LANDING_PAGE = `${DAC_DOCS_BASE_URL}overview/`;

export const DAC_FAQS_DOC_LINK = `${DAC_DOCS_BASE_URL}faqs/`;

export const DAC_SLO_QUALITY_LINK = `${DAC_DOCS_BASE_URL}slo-quality/`;

export const DAC_SLO_LOW_PRIORITY_LINK = `${DAC_DOCS_BASE_URL}low-priority-slos/`;

export const DAC_SLO_HIGH_CARDINALITY_LINK = `${DAC_DOCS_BASE_URL}slo-quality/#slo-contains-high-cardinality-metrics`;

export const DAC_TROUBLESHOOTING_DOC_LINK = `${DAC_DOCS_BASE_URL}troubleshooting/`;

export const DAC_PERFPORTAL_SLO_TUTORIAL_LINK = `${DAC_DOCS_BASE_URL}tutorials/sli-ufo/`;

export const AVATARS_BASE_URL = 'https://staff-avatars.prod.atl-paas.net/avatar';

export const DIRECTORY_BASE_URL = 'https://directory.prod.atl-paas.net/employees';

export const CONFLUENCE_NEGOTIATION_TEMPLATE_LINK =
  'https://hello.atlassian.net/wiki/spaces/SRE/pages/826836574/SLO+Negotiation+-+Reason+for+Negotiation';

export const SLACK_HELP_CHANNEL_LINK = 'https://atlassian.slack.com/archives/C012ACQSMCK';

export const SLIME_DOC_URL =
  'https://hello.atlassian.net/wiki/spaces/PSRE/pages/141248165/SLIME+User+Documentation';

export const MAX_TEXT_LENGTH = 255;

export const COMPLIANCE_PERIOD_IN_DAYS = 28;

// NOTE: Patterns are from the date-fns lib:
// https://date-fns.org/v2.16.1/docs/format
const NUMERIC_DATE_FORMAT = 'dd/MM/yyyy';
const TIME_FORMAT = 'HH:mm:ss';
export const DateDisplayFormats = {
  NUMERIC_DATE: NUMERIC_DATE_FORMAT,
  WORD_MONTH_WITH_DAY: 'MMM do',
  NUMERIC_DATE_WITH_MONTH: 'd. MMM',
  TIME: TIME_FORMAT,
  TIME_WITH_NUMERIC_DATE: `${TIME_FORMAT}, ${NUMERIC_DATE_FORMAT}`,
} as const;

// Values found here under "slo-ui" https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/
export const STATSIG_KEYS = {
  production: '990b7519-9f47-4121-9fd7-53bf0d9f06c5',
  staging: 'e569938b-c239-44d4-ab14-33ae83f39413',
  development: '294f27eb-0744-43ad-87ce-84b9625bc02d',
};

export const TOME_ATLASSIAN_ORG_ID = '4a5c28d6543401018473eb38ce680000';
